module.exports = __webpack_public_path__ + "media/home/digitizedImagesAccess-x1-b7840ca2.png";